import { ThrowLiteError } from '../../lite-error.js';

function decodeSegment(segment) {
  if (/~(?:[^01]|$)/.test(segment)) {
    ThrowLiteError(75, JSON.stringify(segment));
  }
  return segment.replace(/~1/g, "/").replace(/~0/g, "~");
}
function encodeSegment(segment) {
  return segment.replace(/~/g, "~0").replace(/\//g, "~1");
}
function collapseLiteralBrackets(segment) {
  for (const bracket of ["[", "]", "{", "}"]) {
    const runs = segment.match(new RegExp(`\\${bracket}+`, "g")) ?? [];
    if (runs.some((run) => run.length % 2 !== 0)) {
      ThrowLiteError(76, JSON.stringify(segment));
    }
  }
  return segment.replace(/\[\[/g, "[").replace(/\]\]/g, "]").replace(/\{\{/g, "{").replace(/\}\}/g, "}");
}
function parameterId(segment, open, close) {
  if (!segment.startsWith(open) || !segment.endsWith(close)) {
    return null;
  }
  const id = segment.slice(1, -1);
  return id && !["[", "]", "{", "}"].some((bracket) => id.includes(bracket)) ? id : null;
}
function parseJsonPointerTemplate(template) {
  if (!template.startsWith("/")) {
    ThrowLiteError(77);
  }
  const parameters = [];
  const ids = /* @__PURE__ */ new Set();
  const segments = template.slice(1).split("/").map((encoded) => {
    const decoded = decodeSegment(encoded);
    const integer = parameterId(decoded, "[", "]");
    const reference = parameterId(decoded, "{", "}");
    const id = integer ?? reference;
    if (!id) {
      return { literal: encodeSegment(collapseLiteralBrackets(decoded)) };
    }
    if (ids.has(id)) {
      ThrowLiteError(78, JSON.stringify(id));
    }
    ids.add(id);
    const parameter = { id, kind: integer !== null ? "integer" : "reference" };
    parameters.push(parameter);
    return { parameter };
  });
  return { segments, parameters };
}
function substituteJsonPointerTemplate(parsed, valueFor) {
  const segments = [];
  for (const segment of parsed.segments) {
    if (segment.literal !== void 0) {
      segments.push(segment.literal);
      continue;
    }
    const parameter = segment.parameter;
    const value = valueFor(parameter);
    if (parameter.kind === "reference" && typeof value === "string") {
      const match = /(\d+)\/?$/.exec(value);
      if (match) {
        segments.push(match[1]);
        continue;
      }
    }
    const integer = typeof value === "number" ? value : typeof value === "object" && value && "value" in value ? value.value : NaN;
    if (typeof integer === "number" && Number.isInteger(integer) && integer >= 0) {
      segments.push(String(integer));
      continue;
    }
    return null;
  }
  return `/${segments.join("/")}`;
}

export { parseJsonPointerTemplate, substituteJsonPointerTemplate };
//# sourceMappingURL=json-pointer-template.js.map
